var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8947 4.90657L7.63158 8.5M7.63158 8.5L1.3684 4.90657M7.63158 8.5V15.7291M9.10526 15.264L8.20411 15.781C7.99514 15.901 7.89065 15.9608 7.78005 15.9844C7.68205 16.0052 7.58111 16.0052 7.48318 15.9844C7.37251 15.9608 7.26802 15.901 7.05905 15.781L1.6064 12.6527C1.38571 12.5261 1.27534 12.4627 1.19499 12.3726C1.12391 12.2931 1.07011 12.1986 1.0372 12.0957C1 11.9795 1 11.8491 1 11.5883V5.41162C1 5.15089 1 5.02052 1.0372 4.90425C1.07011 4.80138 1.12391 4.70696 1.19499 4.6273C1.27534 4.53725 1.3857 4.47393 1.6064 4.34731L7.05905 1.21895C7.26802 1.09905 7.37251 1.0391 7.48318 1.0156C7.58111 0.994801 7.68205 0.994801 7.78005 1.0156C7.89065 1.0391 7.99514 1.09905 8.20411 1.21895L13.6567 4.34731C13.8775 4.47393 13.9878 4.53725 14.0682 4.6273C14.1392 4.70696 14.1931 4.80138 14.2259 4.90425C14.2632 5.02052 14.2632 5.15089 14.2632 5.41162V8.88048M4.31579 2.79284L10.9474 6.5976M10.5789 13.0657L12.0526 14.5876L15 11.5438",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeals);
export default __webpack_public_path__ + "static/media/icon-deals.5df0a6c3765d86fa3144670c565e3942.svg";
export { ForwardRef as ReactComponent };